import type { GetPaymentInfoResponse } from '@jotta/grpc-connect-openapi/esm/openapi/subscription/payment.v2_pb'
import { FormattedContent } from '@jotta/ui/FormattedContent'
import { Trans } from '@lingui/macro'
import dayjs from 'dayjs'
import { useBrandName } from '@jotta/grpc-connect-client/config'

/* eslint-disable jsx-a11y/anchor-has-content */

export interface SubscriptionRenewalInfoProps {
  subscription: GetPaymentInfoResponse
}

export const SubscriptionExpirationInfo: React.FC<
  SubscriptionRenewalInfoProps
> = ({ subscription: { expirationDateMillis, changeSubscriptionOption } }) => {
  const brandName = useBrandName()

  if (expirationDateMillis) {
    const expirationDate = dayjs(expirationDateMillis.value).format('L')

    switch (changeSubscriptionOption.case) {
      case 'normalUpgrade':
        return (
          <FormattedContent>
            <p>
              <Trans id="subscription_expires_can_convert">
                {expirationDate}
                <a href="/web/expire" className="link" />
              </Trans>
            </p>
          </FormattedContent>
        )

      case 'saSubscription':
        return (
          <FormattedContent>
            <p>
              <Trans id="subscription_expires_sa_subscription">
                {brandName}
                {expirationDate}
                <a href="/web/renew" className="link" />
              </Trans>
            </p>
          </FormattedContent>
        )
      default:
        return (
          <FormattedContent>
            <p>
              <Trans id="subscription_expires">{expirationDate}</Trans>
            </p>
          </FormattedContent>
        )
    }
  } else {
    return null
  }
}
